module.exports = __webpack_public_path__ + "static/media/gma.622c0548.png";